import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/usuarioAcesso/';

class UsuarioAcessoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    selecionarContribuinte(usuario, idUsuarioSelecionado, idContribuinte) {
        return axios.post(API_URL+'selecionarContribuinte?idUsuario='+idUsuarioSelecionado+'&idContribuinte='+idContribuinte, JSON.stringify(usuario),
        {headers: this.headers});
    }

    refreshAccess(usuario) {
        return axios.post(API_URL+'refreshAccess', JSON.stringify(usuario),
        {headers: this.headers});
    }

    findAllByUsuario(idCliente, idUsuario) {
        return axios.get(API_URL + 'allUser?idCliente='+idCliente+'&idUsuario='+idUsuario, {headers: this.headers});
    }

    findAllContrs(idCliente, idUsuario, filtro) {
        return axios.get(API_URL + 'allContr?idCliente='+idCliente+'&idUsuario='+idUsuario+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data.elements));
    }

    findAllByUsuarioFiltro(idCliente, idUsuario, filtro, tipoConsulta, tipoSelecao, pesquisaContador) {
        return axios.get(API_URL + 'allUserFilter?idCliente='+idCliente+'&idUsuario='+idUsuario+'&filtro='+filtro+'&tipo='+tipoConsulta+'&tipoSelecao='+tipoSelecao+'&pesquisaContador='+pesquisaContador, {headers: this.headers});
    }

    
    findAllByContribuinte(idCliente, idContribuinte) {
        return axios.get(API_URL + 'allUserContr?idCliente='+idCliente+'&idContribuinte='+idContribuinte, {headers: this.headers});
    }

    findAllUserAdmin(idCliente){
        return axios.get(API_URL + 'allUserAdmin?idCliente='+idCliente, {headers: this.headers})
    }

    remove(usuarioAcessoId) {
        return axios.delete(API_URL+usuarioAcessoId);
    }

    removerUserEmpresa(idUsuario, idContribuinte) {
        return axios.post(API_URL+'removerEmpresa?idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, null,
        {headers: this.headers});
    }

    adicionarUserEmpresa(idUsuario, idContribuinte, idCliente) {
        return axios.post(API_URL+'adicionarEmpresa?idUsuario='+idUsuario+'&idContribuinte='+idContribuinte+'&idCliente='+idCliente, null,
        {headers: this.headers});
    }
}

export default new UsuarioAcessoService();